import React, { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import PropertySearch from "./home/PropertySearch";
import FeaturedListings from "./home/FeaturedListings";
import { services, blogPosts } from "./data/data";
import * as LucideIcons from "lucide-react";
import { Grid } from "../../ui/Grid";
import {
  Globe,
  Users,
  Shield,
  BarChart,
  Calendar,
  ArrowRight,
  Phone,
  UserCircle,
  BedDouble,
  Bath,
  Car,
  Ruler,
  LocateFixed,
  Tags,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import Testimonials from "./home/Testimonials";
import { motion } from "framer-motion";
import Faqs from "./home/Faqs";
import {
  scrollVariantsLeft,
  scrollVariantsRight,
} from "../../../constants/TextAnimation";
import YouTubeShortsPlayer from "./common/YouTubeShortsPlayer";
import { useFunctionContext } from "../../context/FunctionalContext";

const features = [
  {
    icon: <Globe size={40} className="text-secondary" />,
    title: "Trusted Global Network",
    description:
      "Access to properties and clients in over 60 countries through our exclusive international partnerships.",
  },
  {
    icon: <Users size={40} className="text-secondary" />,
    title: "Local Market Experts",
    description:
      "Dedicated specialists with deep knowledge of regional markets, trends, and opportunities.",
  },
  {
    icon: <Shield size={40} className="text-secondary" />,
    title: "Transparent Processes",
    description:
      "Clear communication and comprehensive guidance throughout every transaction.",
  },
  {
    icon: <BarChart size={40} className="text-secondary" />,
    title: "Tech-Driven Property Solutions",
    description:
      "Advanced analytics and digital tools to optimize your property search and investment decisions.",
  },
];

const Home = () => {
  // Dynamic icon rendering based on icon name in data
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const { listings, listLoading } = useFunctionContext();

  const investorFriendlyProject = listings.filter(
    (listing) => listing.listing_type === "Investor Friendly Project"
  );

  const renderIcon = (iconName) => {
    const Icon = LucideIcons[iconName];
    return Icon ? <Icon size={32} className="text-secondary mb-4" /> : null;
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <>
      {/* hero */}
      <div className="relative h-[125vh h-dvh lg:h-scree flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
          // style={{
          //   backgroundImage: `url("/images/realty/13.webp")`,
          // }}
        >
          <video
            src="/videos/video2.mp4"
            className="rounded-2xl order-3 lg:order-2 w-full h-auto object-cover shadow-xl"
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/85 z-10"></div>
        </div>

        {/* Content */}
        <div className="container px-4 md:px-6 relative z-20 flex justify-center">
          {/* Left Content */}
          <div className="text-center lg:text-lef lg:pt-14">
            <h1 className="text-5xl md:text-5xl lg:text-6xl xl:text-7xl text-white font-bold leading-tight mb-4 mt- md:mb-6">
              Invest in Dubai&apos;s <br className="hidden lg:block" /> Future
            </h1>

            <p className="text-lg md:text-lg max-w-xl mx-auto lg:mx-0 lg:text-xl text-gray-100 mb-8 md:mb-10">
              Discover exclusive investment opportunities and navigate
              Dubai&apos;s dynamic property landscape with our expert guidance,
              tailored to maximize your investment potential.
            </p>

            <div className="flex flex-col md:flex-row gap-4 justify-center lg:justify-star">
              <button
                className="bg-gold hover:bg-opacity-80 text-slate-900 font-medium px-8 py-3 rounded-md transition-colors shadow-md flex items-center justify-center gap-2 group"
                onClick={() => navigate("/realty/listings")}
              >
                Start Exploring
                <ChevronRight
                  size={18}
                  className="transition-transform group-hover:translate-x-1"
                />
              </button>
              <Link
                to="/realty/contact"
                className="bg-transparent hover:bg-white/10 text-white border-2 border-white font-medium px-8 py-3 rounded-md transition-colors"
              >
                Contact Us
              </Link>
            </div>
          </div>

          {/* Right Side Video */}
          {/* <div className="w-full h-full relative flex justify-center lg:justify-end">
            <div className="absolute inset-0 bg-gradient-to-r from-slate-700 via-slate-900 to-gold rounded-xl shadow-2xl opacity-75"></div>
            <div className="relative w-full max-w-l aspect-video py-5 ps-4 pe-4 mdps-10">
              {loading ? (
                <>
                  <div className="flex items-center justify-center h-full">
                    {" "}
                    <div className="w-10 h-10 border-4 border-gray-300 border-t-gold rounded-full animate-spin"></div>{" "}
                  </div>
                </>
              ) : (
                // <iframe
                //   className="w-full rounded-xl shadow-lg border border-slate-400 h-full lg:h-[340px]"
                //   // src="https://www.youtube.com/embed/videoseries?list=PLWKjhJtqVAbn21gs5UnLhCQ82f923WCgM"
                //   src="https://www.youtube.com/embed/_KMo8wWkm1M"
                //   title="YouTube video"
                //   frameBorder="0"
                //   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                //   allowFullScreen
                // ></iframe>
                <YouTubeShortsPlayer />
              )}
            </div>
          </div> */}
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20">
          <div className="w-8 h-12 border-2 border-white/50 rounded-full flex justify-center">
            <div className="w-1.5 h-3 bg-white/80 rounded-full mt-2 animate-bounce"></div>
          </div>
        </div>
      </div>

      {/* <div className="container mx-auto px-4 md:px-6 relative z-20">
        <PropertySearch />
      </div> */}

      <FeaturedListings />

      {/* about */}

      <section className="flex flex-col lg:flex-row items-center justify-between gap-10 container py-16 md:py-24">
        {/* Left Side */}
        <motion.div
          variants={scrollVariantsLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          className="lg:w-1/2 space-y-6"
        >
          <button className="flex items-center gap-2 px-4 py-2 bg-slate-800 rounded-full shadow text-sm font-medium">
            <UserCircle className="w-5 h-5" />
            About us
          </button>

          <h1 className="text-4xl lg:text-5xl font-bold ">
            Looking for the <br /> Perfect Investment?
          </h1>

          <p className="text-gray-00 text-base lg:text-base leading-relaxed">
            Scan Global Realty will help you find the best investment tailored
            to your goals and budget. We ensure your investment aligns with your
            future plans, making it the right choice for long-term success.
            Start your journey in Dubai’s real estate market today!
          </p>

          <button
            className="flex items-center gap-2 px-6 py-3 bg-gold text-slate-900 font-semibold rounded-full shadow hover:bg-opacity-80 transition-all"
            onClick={() => navigate("/realty/blog")}
          >
            Start exploring
            <ArrowRight className="w-4 h-4" />
          </button>
        </motion.div>

        {/* Right Side */}
        <motion.div
          variants={scrollVariantsRight}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          className="lg:w-1/2 mt-10 lg:mt-0 relative"
        >
          <img
            src="/images/realty/4.jpg"
            alt="Dubai Real Estate"
            className="rounded-2xl w-full h-auto"
          />

          {/* Tag: 3 bathrooms */}
          <div className="absolute top-6 left-0">
            <div className="flex items-center gap-2 bg-gold text-slate-900 px-4 py-2 rounded-xl shadow text-sm font-medium">
              <Bath className="w-4 h-4 text-gray-600" />3 bathrooms
            </div>
          </div>

          {/* Tag: 6 parking zones */}
          <div className="absolute bottom-6 left-8">
            <div className="flex items-center gap-2 bg-gold text-slate-900 px-4 py-2 rounded-xl shadow text-sm font-medium">
              <Car className="w-4 h-4 text-gray-600" />6 parking zones
            </div>
          </div>

          {/* Tag: 4,821 sqft */}
          <div className="absolute top-6 right-0">
            <div className="flex items-center gap-2 bg-gold text-slate-900 px-4 py-2 rounded-xl shadow text-sm font-medium">
              <Ruler className="w-4 h-4 text-gray-600" />
              4,821 sqtf
            </div>
          </div>

          {/* Tag: 3 bedrooms */}
          <div className="absolute bottom-1/2 right-6 translate-y-1/2">
            <div className="flex items-center gap-2 bg-gold text-slate-900 px-4 py-2 rounded-xl shadow text-sm font-medium">
              <BedDouble className="w-4 h-4 text-gray-600" />3 bedrooms
            </div>
          </div>
        </motion.div>
      </section>

      {/* services */}
      <section className="py-5 md:py-18">
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gold mb-4">
              Our Services
            </h2>
            <p className="text-gray-400 text-lg">
              Comprehensive real estate solutions tailored to your unique needs
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div
                key={service.id}
                className="bg-slate-900/60 relative overflow-hidden rounded-lg p-8 shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              >
                <Grid size={25} />
                {renderIcon(service.icon)}
                <h3 className="text-xl font-bold mb-3">{service.title}</h3>
                <p className="text-gray-400">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* why choose us */}
      <section className="py-10 md:py-18">
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gold mb-4">
              Why Choose Us
            </h2>
            <p className="text-gray-400 text-lg">
              What sets Scan Global Realty apart from other real estate agencies
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-slate-900/60 rounded-lg p-8 border border-gray-900 transition-all duration-300 hover:border-blue-200 hover:shadow-md"
              >
                <div className="flex flex-col md:flex-row md:items-start gap-4">
                  <div className="mb-4 md:mb-0 flex items-center justify-center">
                    <div className="p-3 bg-secondary/10 rounded-lg">
                      {feature.icon}
                    </div>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold  mb-2">{feature.title}</h3>
                    <p className="text-gray-400">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* latest insights */}
      <section className="py-8 md:py-20">
        <div className="container mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gold mb-3">
                Investor friendly projects
              </h2>
              <p className="text-gray-400 max-w-2xl">
                Discover opportunities designed for maximum returns and
                long-term growth
              </p>
            </div>

            <div className="mt-4 md:mt-0">
              <Link
                to="/realty/listings#investor-friendly-project"
                className="rounded-full bg-gradient text-slate-900 px-4 py-2 font-medium hover:text-opacity-80 inline-flex items-center gap-2 transition-colors"
              >
                View All <ArrowRight size={20} />
              </Link>
            </div>
          </div>

          {listLoading ? (
            <ListingSkeleton count={4} />
          ) : !investorFriendlyProject ||
            investorFriendlyProject.length == 0 ? (
            <div className="py-20 text-center w-full">
              <h3 className="text-2xl font-semibold mb-2 bg-gradient-to-r from-gold via-slate-500 to-gold bg-[length:200%_auto] text-transparent bg-clip-text animate-gradient">
                Coming Soon ⭐
              </h3>
              <p className="text-gray-400 text-sm">
                Our listings are being updated. Please check back soon or
                contact our team for exclusive previews.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
              {investorFriendlyProject.slice(0, 4).map((list) => (
                <article
                  key={list.listing_id}
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    navigate(`/realty/listings/${list?.listing_id || ""}`);
                  }}
                  className=" rounded-lg overflow-hidden shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:border-blue-200"
                >
                  <div className="aspect-[16/9] overflow-hidden">
                    <img
                      src={list.images?.[0]?.url}
                      alt={list.name}
                      className="w-full h-full object-cover cursor-pointer rounded-3xl transition-transform duration-500 hover:scale-110"
                    />
                    {/* <div className="absolute top-4 left-4 bg-black text-white px-3 py-1 rounded-md text-xs font-medium">
                    <Tags />
                    {list.category}
                  </div> */}
                  </div>

                  <div className="p-6">
                    <div className="flex items-center text-gray-400 mb-3">
                      <Calendar size={16} className="mr-2" />
                      <span className="text-sm">
                        {new Date(list.createdAt).toLocaleDateString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        })}
                      </span>
                    </div>

                    <h3 className="text-xl font-bold mb-2 line-clamp-2">
                      {list.name}
                    </h3>

                    <p className="text-gray-400 mb-2 line-clamp-3 flex items-center gap-1">
                      <LocateFixed size={15} className="text-gold" />{" "}
                      {list.location.address}, {list.location.city},{" "}
                      {list.location.state}
                    </p>

                    <Link
                      to="/realty/contact"
                      className="inline-flex items-center text-gold font-medium hover:text-opacity-80 transition-colors group"
                    >
                      Contact agent
                      <ArrowRight
                        size={16}
                        className="ml-2 transition-transform group-hover:translate-x-1"
                      />
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* testimonials */}
      <Testimonials />

      <section className="py-16 md:py-24">
        <Faqs />
      </section>

      {/* call to action */}
      <section className="pb-16 md:pb-32 relative overflow-hidden">
        {/* Decorative Elements */}
        {/* <div className="absolute top-0 right-0 w-64 h-64 bg-blue-800 rounded-full opacity-30 translate-x-1/3 -translate-y-1/3"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-800 rounded-full opacity-30 -translate-x-1/3 translate-y-1/3"></div> */}

        <div className="container mx-auto px-4 md:px-6 pb-10 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              Find Your Ideal Property
            </h2>

            <p className="text-gray-400 text-base md:text-lg mb-8 max-w-2xl mx-auto">
              Access a curated selection of properties perfect for your unique
              requirements
            </p>

            <Link to="/realty/contact">
              <button className="bg-gradient hover:bg-opacity-80 text-slate-900 font-medium px-8 py-2 rounded-md transition-colors shadow-lg inline-flex items-center gap-2 text-lg">
                <Phone size={20} />
                Schedule a Call
              </button>{" "}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;

const ListingSkeleton = ({ count = 4 }) => {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, index) => (
        <article
          key={index}
          className="rounded-lg overflow-hidden shadow-md bg-slate-900/40 animate-pulse"
        >
          {/* Image skeleton */}
          <div className="aspect-[16/9] bg-slate-700/60 rounded-3xl"></div>

          {/* Text skeleton */}
          <div className="p-6 space-y-4">
            {/* Date skeleton */}
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 bg-slate-700 rounded-full"></div>
              <div className="h-3 w-24 bg-slate-700 rounded"></div>
            </div>

            {/* Title skeleton */}
            <div className="h-5 w-3/4 bg-slate-700 rounded"></div>

            {/* Description skeleton */}
            <div className="space-y-2">
              <div className="h-3 w-full bg-slate-700 rounded"></div>
              <div className="h-3 w-5/6 bg-slate-700 rounded"></div>
              <div className="h-3 w-2/3 bg-slate-700 rounded"></div>
            </div>

            {/* Button skeleton */}
            <div className="h-8 w-32 bg-slate-700 rounded"></div>
          </div>
        </article>
      ))}
    </div>
  );
};
